import angular from 'angular';

(function() {
  'use strict';
  angular.module('app.core').factory('Attribute', AttributeData);

  /* @ngInject */
  function AttributeData() {
    Attribute.prototype = {
      build: build,
      buildEmpty: buildEmpty,
      isStandard: isStandard
    };

    function Attribute(AttributeData) {
      if (!AttributeData) {
        this.buildEmpty();
      } else {
        this.build(AttributeData);
      }
    }

    return Attribute;

    /////////////////////
    function buildEmpty() {
      this.name = null;
      this.label = null;
      this.type = null;
      this.path = null;
      this.category = null;
      this.multiple = null;
      this.rawOrder = null;
      this.order = null;
      this.mandatory = null;
      this.group = null;
      this.visible = null;
      this.classColumn = null;
      this.validation = null;
      this.section = null;
      this.internalData = null;
      this.rawOrder = -1;
    }

    function build(attributeData) {
      this.name = attributeData.name || null;
      this.label = attributeData.label || null;
      this.type = attributeData.type || null;
      this.path = attributeData.path || null;
      this.category = attributeData.category || null;
      this.multiple = attributeData.multiple || null;
      this.rawOrder = attributeData.rawOrder || null;
      this.order = attributeData.order || null;
      this.mandatory = attributeData.mandatory || null;
      this.group = attributeData.group || null;
      this.visible = attributeData.visible;
      this.classColumn = attributeData.classColumn || null;
      this.section = attributeData.section || null;
      this.validation = attributeData.validation || null;
      this.internalData = attributeData.internalData || null;
    }

    function isStandard() {
      return this.mandatory || this.rawOrder !== -1;
    }
  }
})();
